import script from "./DownloadFormatDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadFormatDialog.vue?vue&type=script&setup=true&lang=js"

import "./DownloadFormatDialog.vue?vue&type=style&index=0&id=133c62b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133c62b4"]])

export default __exports__